export const getGoogleMapsApiKey = () => window.env?.GOOGLE_MAPS_API_KEY;

export const getLoqateApiKey = () => window.env?.LOQATE_API_KEY;
